export default {
  container: {
    marginTop: '1rem',
    '& p': {
      margin: '1rem 0 0 0'
    }
  },
  infoText: {
    display: 'inline-block'
  },
  list: {
    marginBottom: 0,
    paddingTop: '.5rem',
    listStyle: 'none'
  }
}



// WEBPACK FOOTER //
// ./src/components/FloorPlanUploader/FileInfo/style.js